import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../store/slices/authSlice";
import Icon from "../../components/Common/Icon";
import { useToast } from "../../context/ToastContext";

export default function ChangePasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const user = useSelector((state) => state.auth.user);
  const forced = user?.mustChangePassword;

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirm) {
      setError("Yeni şifreler eşleşmiyor");
      showToast("Yeni şifreler eşleşmiyor", "error");
      return;
    }
    setLoading(true);
    const result = await dispatch(changePassword({ oldPassword, newPassword }));
    setLoading(false);
    if (changePassword.fulfilled.match(result)) {
      showToast("Şifreniz başarıyla güncellendi.", "success");
      navigate("/dashboard");
    } else {
      setError(result.payload);
      showToast(result.payload || "Şifre değiştirme başarısız.", "error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10 p-4">
      <div className="w-full max-w-md bg-surface-card rounded-3xl shadow-modal p-8">
        <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-4">
          <Icon name="lock_reset" className="!text-[28px]" />
        </div>
        <h1 className="text-2xl font-bold text-on-surface">Şifre Değiştir</h1>
        <p className="text-on-surface-variant text-sm mt-1">
          {forced
            ? "Geçici şifreyle giriş yaptınız. Devam etmek için yeni bir şifre belirleyin."
            : "Hesabınız için yeni bir şifre belirleyin."}
        </p>

        {error && (
          <div className="mt-4 flex items-center gap-2 text-sm text-error bg-error/10 rounded-xl px-4 py-3">
            <Icon name="error" className="!text-[18px]" /> {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <PwdField label="Mevcut (geçici) şifre" value={oldPassword} onChange={setOldPassword} />
          <PwdField label="Yeni şifre" value={newPassword} onChange={setNewPassword} />
          <PwdField label="Yeni şifre (tekrar)" value={confirm} onChange={setConfirm} />
          <p className="text-xs text-on-surface-variant">
            En az 8 karakter, 1 büyük harf ve 1 rakam içermeli.
          </p>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-white rounded-xl py-3 font-semibold hover:opacity-90 transition active:scale-[0.99] disabled:opacity-50"
          >
            {loading ? "Kaydediliyor…" : "Şifreyi Güncelle"}
          </button>
        </form>
      </div>
    </div>
  );
}

function PwdField({ label, value, onChange }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="block text-sm font-medium mb-1.5 text-on-surface-variant">{label}</label>
      <div className="relative">
        <input
          type={show ? "text" : "password"}
          required
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full border border-outline-variant rounded-xl pl-3.5 pr-11 py-2.5 focus:ring-4 focus:ring-primary/15 focus:border-primary outline-none transition bg-white"
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-3.5 top-3 text-on-surface-variant hover:text-primary transition"
        >
          <Icon name={show ? "visibility_off" : "visibility"} className="!text-[20px]" />
        </button>
      </div>
    </div>
  );
}
